function e(e,n){var d;return(null===(d=e.securedFields[n])||void 0===d?void 0:d.iframeContentWindow)||null}export{e as default};
//# sourceMappingURL=getIframeContentWin.js.map
